// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import { Link, withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import ConstraintViolationsByOrderTable from './components/constraint-violations-by-order-table';
import LabeledInput from '../../shared/components/labeled-input';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    getViolationsByOrder
} from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

class ConstraintViolationsByOrder extends Component {

    state = {
        selectedOrderNumber: '',
        results: null
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryOrderNum = query.get( 'ordernum' );
        if ( queryOrderNum ) {

            this.handleOrderNumberChange( queryOrderNum );
            this.handleViolationCall( queryOrderNum );

        }

    }

    componentDidUpdate = prevProps => {

        if ( this.props.location.search !== prevProps.location.search ) {

            const query = new URLSearchParams( this.props.location.search );
            const queryOrderNum = query.get( 'ordernum' );
            if ( queryOrderNum ) {

                this.handleOrderNumberChange( queryOrderNum );
                this.handleViolationCall( queryOrderNum );

            }
            window.scrollTo( 0, 0 );

        }

    }

    handleOrderNumberChange ( val ) {

        const orderNum = val.target ? val.target.value : val;

        this.setState( {

            selectedOrderNumber: orderNum

        } );

    }

    handleViolationCall ( orderNumber ) {

        this.props.increaseCounter();
        getViolationsByOrder( orderNumber )
            .then( response => {

                this.setState( {
                    results: response
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    refresh () {

        this.handleViolationCall( this.state.selectedOrderNumber );

    }

    render () {

        const {
            selectedOrderNumber, results
        } = this.state;

        let previousDate = '';
        let previousTime = '';
        const mapResults = [];
        let orderedResult = [];
        let j = 0;
        let k = 1;
        if ( results !== null && results.orders !== null ) {

            for ( let i = 0; i < results.orders.length; i += 1 ) {

                if ( ( previousDate !== '' && previousTime !== '' && ( previousDate !== results.orders[i].transDate || previousTime !== results.orders[i].transTime ) ) || i === results.orders.length - 1 ) {

                    const resultWithUnitName = orderedResult.map( order => (
                        { ...order, ...{ unitName: this.props.unit.name } } ) );
                    mapResults[k] = resultWithUnitName;
                    orderedResult = [];
                    j = 0;
                    k += 1;

                }
                orderedResult[j] = results.orders[i];
                j += 1;
                previousDate = results.orders[i].transDate;
                previousTime = results.orders[i].transTime;

            }

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Constraint Violations By Order</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-constraint-violations-by-order-top-options">
                            <div className="label-input">
                                <LabeledInput
                                    className="atp-constraint-violations-by-order-label-input"
                                    label="Order Number"
                                    name="orderNumber"
                                    onChange={this.handleOrderNumberChange.bind( this )}
                                    isRequired={false}
                                    maxLength={12}
                                    isEditable={true}
                                    value={selectedOrderNumber}
                                />

                                {selectedOrderNumber && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        <div className="displayMessage">
                            {results !== null && results.orders.length === 0 && (
                                <div id="displayErrorMessage">There are no records to display for order {selectedOrderNumber}.</div>
                            ) }
                            <div>{mapResults.length > 0 && ` Order Number: ${selectedOrderNumber} ` }</div>
                            <div>{results !== null && results.showTransactionLink === true ?
                                <Link to={`/${this.props.unit.name}/order/transaction-log?ordernumber=${selectedOrderNumber.trim()}`}>view Transaction log</Link> : ''
                            }
                            </div>
                        </div>
                        {results !== null && mapResults.map( ( item, index ) => (
                            <ConstraintViolationsByOrderTable
                                key={`violations-table-${index}`}
                                results={item}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

ConstraintViolationsByOrder.displayName = 'ConstraintViolationsByOrder';
ConstraintViolationsByOrder.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( ConstraintViolationsByOrder ) );
